module.exports = __webpack_public_path__ + "static/asa-5a29109a6c930d7ce0dd442e37c6470a.jpg";